import { Injectable } from '@angular/core';
import { MessageBoxButtons, MessageBoxIcon, MessageMode } from './messages.model';

@Injectable()
export class MessageSettings {
  mode: MessageMode = MessageMode.None;
  caption: string;
  message: string;
  errorMessage: string;
  htmlcode?: HTMLDivElement;
  icon: MessageBoxIcon;
  button: MessageBoxButtons;
  okButtonText?: string;
  cancelButtonText?: string;
}
